import "./Admin.css";

import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import {Typeahead} from "react-bootstrap-typeahead";
import Table from "react-bootstrap/Table";
import fixtureService from "../../services/FixtureService";
import ageGradeCategoryService from "../../services/AdminServices/AgeGradeCategoryService";
import teamsService from "../../services/TeamsService";
import FixtureDetailsModal from "../Modals/FixtureDetailsModal";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import authorizeService from "../api-authorization/AuthorizeService";

const AdminFixtures = (props) => {
    const typaheadRef = React.createRef();

    const [loading, setLoading] = useState(true);
    const [fixtureList, setFixtureList] = React.useState(null);
    const [ageGradeList, setAgeGradeList] = React.useState(null);
    const [teamList, setTeamList] = React.useState(null);
    const [selectedTeams, setSelectedTeams] = React.useState(null);
    const [showDetailsModal, setShowDetailsModal] = React.useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedFixture, setSelectedFixture] = useState(null);
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (!userRole) {
            authorizeService.getUserRole().then((role) => {
                setUserRole(role);
            });
        }
    }, [userRole]);

    useEffect(() => {
        if (!teamList) {
            teamsService.getTeamsList().then((teams) => {
                setTeamList(teams);
            });
        }
    }, [teamList]);

    useEffect(() => {
        if (!fixtureList) {
            fixtureService.getFixtureList().then((fixtures) => {
                setFixtureList(fixtures);
                setLoading(false);
            });
        }
    }, [fixtureList]);

    useEffect(() => {
        if (!ageGradeList) {
            ageGradeCategoryService.getAgeGradeCategoriesList().then((ageGrades) => {
                setAgeGradeList(ageGrades);
            });
        }
    }, [ageGradeList]);

    useEffect(() => {
        if (startDate || endDate) {
            fixtureService.getFixtureList().then((fixtures) => {
                setFixtureList(
                    getFilteredFixtures(fixtures, selectedTeams, startDate, endDate)
                );
            });
        }
    }, [startDate, endDate, selectedTeams]);

    const hideModal = async (success) => {
        setShowDetailsModal(false);
        if (success) {
            fixtureService.getFixtureList().then((fixtures) => {
                setFixtureList(fixtures);
            });
        }
    };

    const renderFixtureDetailModal = () => {
        if (selectedFixture) {
            return (
                <FixtureDetailsModal
                    show={showDetailsModal}
                    onHide={hideModal}
                    userRole={userRole}
                    fixture={selectedFixture}
                ></FixtureDetailsModal>
            );
        } else {
            return <></>;
        }
    };

    const renderTeamDropdown = (teamList, setSelectedTeams) => {
        if (teamList) {
            let typaheadNames = teamList.map((x) => {
                return {id: x.id, label: `${x.name}`};
            });

            return (
                <Typeahead
                    id="teams-typahead"
                    ref={typaheadRef}
                    clearButton
                    multiple
                    onChange={(selected) => {
                        if (selected && selected.length > 0) {
                            setSelectedTeams(selected.map((x) => x.label));
                        } else {
                            setSelectedTeams(null);
                        }
                    }}
                    options={typaheadNames}
                    placeholder="Type to search Team"
                />
            );
        }
        return <></>;
    };

    const renderTable = (fixtures) => {
        let content = <></>;
        if (loading) {
            content = (
                <tr className="p-2">
                    <td colSpan="10" className="text-center">
                        Loading...
                    </td>
                </tr>
            );
        } else if (!fixtures || fixtures.length == 0) {
            content = (
                <tr className="p-2">
                    <td colSpan="8" className="text-center">
                        No Fixtures
                    </td>
                </tr>
            );
        } else {
            content = fixtures.map((x) => {
                return (
                    <tr key={x.fixtureId}>
                        <td>{x.fixtureId}</td>
                        <td>{x.homeTeamName}</td>
                        <td>{x.awayTeamName}</td>
                        <td>{x.competitionName}</td>
                        <td>{x.dateString}</td>
                        <td>{x.kickoffTime}</td>
                        <td className={x.roomEnded == true ? "text-success" : "dull-text"}>
                            <i className="fa-solid fa-circle-check ml-2"></i> Complete
                        </td>
                        <td className={x.videoUrl != null ? "text-success" : "dull-text"}>
                            <i className="fa-solid fa-circle-check ml-2"></i> Video
                        </td>
                        <td className="fit">
                            <Button
                                variant="outline-secondary"
                                onClick={async (clickInfo) => {
                                    setSelectedFixture(x);
                                    setShowDetailsModal(true);
                                }}
                            >
                                {" "}
                                Details{" "}
                            </Button>
                        </td>
                    </tr>
                );
            });
        }

        return (
            <>
                <div
                    style={{
                        overflowY: "scroll",
                        overflowX: "scroll",
                        whiteSpace: "nowrap",
                        maxHeight: "calc(100vh - 180px)",
                    }}
                >
                    <Table striped bordered hover className="react-bootstrap-table">
                        <thead>
                        <tr>
                            <th>BureauId</th>
                            <th>Home Team</th>
                            <th>Away Team</th>
                            <th>Competition</th>
                            <th>Date</th>
                            <th>Kick off Time</th>
                            <th>Scoring Complete</th>
                            <th>Video</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>{content}</tbody>
                    </Table>
                </div>
            </>
        );
    };

    let getFilteredFixtures = (
        fixtures,
        selectedTeams,
        selectedStartdate,
        selectedEndDate
    ) => {
        if (!selectedTeams || !Array.isArray(selectedTeams)) {
            selectedTeams = [];
        }
        if (selectedStartdate && !selectedEndDate) {
            return fixtures
                .filter((x) => x.date >= selectedStartdate)
                .filter((x) => {
                    return (
                        selectedTeams.length === 0 ||
                        selectedTeams.some(
                            (y) => x.homeTeamName == y || x.awayTeamName == y
                        )
                    );
                });
        } else if (!selectedStartdate && selectedEndDate) {
            return fixtures
                .filter((x) => x.date <= selectedEndDate)
                .filter((x) => {
                    return (
                        selectedTeams.length === 0 ||
                        selectedTeams.some(
                            (y) => x.homeTeamName == y || x.awayTeamName == y
                        )
                    );
                });
        } else if (selectedStartdate && selectedEndDate) {
            return fixtures
                .filter((x) => x.date >= selectedStartdate && x.date <= selectedEndDate)
                .filter((x) => {
                    return (
                        selectedTeams.length === 0 ||
                        selectedTeams.some(
                            (y) => x.homeTeamName == y || x.awayTeamName == y
                        )
                    );
                });
        } else {
            return fixtures.filter((x) => {
                return (
                    selectedTeams.length === 0 ||
                    selectedTeams.some((y) => x.homeTeamName == y || x.awayTeamName == y)
                );
            });
        }
    };

    const filteredFixtures = React.useMemo(() => {
        let filteredFixtures = fixtureList
            ? getFilteredFixtures(fixtureList, selectedTeams, startDate, endDate)
            : [];

        return filteredFixtures;
    }, [fixtureList, selectedTeams, startDate, endDate]);

    let title = <h1 id="tabelLabel">Fixtures</h1>;
    let contents = renderTable(filteredFixtures);
    let teamDropdown = renderTeamDropdown(teamList, setSelectedTeams);
    let fixtureDetailModal = renderFixtureDetailModal();

    return (
        <div>
            <div>
                <Row className="mr-0">
                    <Col>{title}</Col>
                </Row>
                <Row className="mb-2 ml-0 mr-0">
                    <Form.Label htmlFor="startDate" style={{fontWeight: "bold"}}>
                        Filter Start Date
                    </Form.Label>
                    <Col>
                        <Form.Control
                            id="startDate"
                            type="date"
                            onChange={(event) => {
                                setStartDate(event.target.value);
                            }}
                        />
                    </Col>
                    <Form.Label htmlFor="endDate" style={{fontWeight: "bold"}}>
                        Filter End Date
                    </Form.Label>
                    <Col>
                        <Form.Control
                            id="endDate"
                            type="date"
                            onChange={(event) => {
                                setEndDate(event.target.value);
                            }}
                        />
                    </Col>
                    <Col sm="6" lg="4">
                        {teamDropdown}
                    </Col>
                </Row>
                {contents}
                {fixtureDetailModal}
            </div>
        </div>
    );
};

AdminFixtures.displayName = AdminFixtures.name;

export default AdminFixtures;
